import { requests } from '@/libs/axios/axios'
import { LicenseEndpoints } from '../license-endpoints'
import { EditLicenseData } from '../license.interfaces'

async function requestLicenseChange(license: Partial<EditLicenseData>, id: number) {
  return requests.post(`${LicenseEndpoints.LICENSE}/${id}/request-change`, license)
}

export default requestLicenseChange
